<template>
  <div class="activityStyle">
    <div class="content-box">
      <div class="left-show" v-if="!isEven(showIndex)">
        <Swiper
          class="left-activityStyle-img"
          :showData="showData.showImg"
          :showIndex="showData.id"
          :key="`swiper-left-${showData.id}`"
        />
        <div class="left-activityStyle-title">
          <div class="style-title">
            {{ lan ? showData.activityEnTitle : showData.activityCnTitle }}
          </div>
          <div
            class="style-subTitle-time"
            v-if="showData.startDate"
          >
            {{ formatActivityDate(showData.startDate, showData.endDate) }}
          </div>
          <div class="style-subTitle">
            {{ lan ? showData.activityEnBrief : showData.activityCnBrief }}
          </div>
        </div>
      </div>
      <div class="right-show" v-else>
        <div class="right-activityStyle-title">
          <div class="style-title">
            {{ lan ? showData.activityEnTitle : showData.activityCnTitle }}
          </div>
          <div
            class="style-subTitle-time"
            v-if="showData.startDate"
          >
            {{ formatActivityDate(showData.startDate, showData.endDate) }}
          </div>
          <div class="style-subTitle">
            {{ lan ? showData.activityEnBrief : showData.activityCnBrief }}
          </div>
        </div>

        <Swiper
          class="right-activityStyle-img"
          :showData="showData.showImg"
          :showIndex="showData.id"
          :key="`swiper-right-${showData.id}`"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "./swiper.vue";

export default {
  name: "ActivityStyle",
  components: {
    Swiper,
  },
  props: {
    showData: {
      type: Object,
      default: () => ({}),
    },
    showIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      lan: this.$store.state.isEn,
    };
  },
  watch: {
    "$store.state.isEn"(newVal) {
      this.lan = newVal;
    },
    showData: {
      handler() {
        // 监听showData变化，确保组件及时更新
      },
      deep: true
    }
  },
  methods: {
    isEven(num) {
      return num % 2 === 0;
    },
    // 格式化活动日期显示
    formatActivityDate(startDate, endDate) {
      // 如果没有结束日期或者开始日期和结束日期相同，则只显示开始日期
      if (!endDate || startDate === endDate) {
        return startDate || '';
      }
      // 否则显示日期范围格式
      return `${startDate || ''}-${endDate || ''}`;
    }
  },
};
</script>

<style scoped>
.content-box {
  width: 1440px;
  margin: 40px auto;
  transition: all 0.3s ease;
}
.right-show {
  display: flex;
  height: 600px;
}
.right-activityStyle-title {
  width: 520px;
  margin-right: 40px;
}
.right-activityStyle-img {
  width: 880px;
  height: 600px;
}
.left-show {
  display: flex;
  height: 600px;
}
.left-activityStyle-title {
  width: 520px;
  margin-left: 40px;
}
.left-activityStyle-img {
  width: 880px;
  height: 600px;
}
.style-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: Bold;
}
.style-subTitle {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  line-height: 32px;
  font-weight: Regular;
  margin-top: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 11;
}
.style-subTitle-time {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #98989f;
  letter-spacing: 0;
  text-align: left;
  margin-top: 10px;
  font-weight: 400;
}
@media (max-width: 1440px) {
  .activityStyle {
    max-width: 98%;
    margin: 0px auto;
  }
  .content-box {
    max-width: 92%;
    margin: 20px auto;
  }
  .right-show {
    width: 100%;
    display: flex;
    height: auto;
    justify-content: center;
  }
  .right-activityStyle-title {
    max-width: 50%;
    margin-right: 20px;
    height: 400px;
  }
  .right-activityStyle-img {
    max-width: 50%;
    object-fit: cover;
    height: 400px;
  }
  .left-show {
    display: flex;
  }
  .left-activityStyle-title {
    max-width: 50%;
    margin-left: 40px;
    height: 400px;
  }
  .left-activityStyle-img {
    max-width: 50%;
    object-fit: cover;
    height: 400px;
  }
  .style-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 28px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: Bold;
  }
  .style-subTitle {
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    line-height: 26px;
    font-weight: Regular;
    margin-top: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 14;
  }
  .style-subTitle-time {
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    color: #98989f;
    letter-spacing: 0;
    text-align: left;
    margin-top: 10px;
    font-weight: 400;
  }
}
</style>